import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "../RerouteModal/RerouteModalStyles.css";
import { getRerouteUser, transferOwnership } from "../../../API/api";
import { toast } from "react-toastify";
import {RetweetOutlined} from "@ant-design/icons";
import {Select} from 'antd';
import MultiSelectCm from "../../MultiSelectCm/MultiSelectCm";
import Styles from './TransfereBulk.module.css'

const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};
const textStyles1 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  textAlign: "left"
};
export default function TransferOwnershipBulk() {
    const [isLoading, isLoaded] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedExpert, setSelectedExpert] = useState([]);
    const expertRecordsState = useSelector((state) => state.expertRecord);
    const successMsg = (message) => {
        return (
          <>
            <span style={{ fontSize: "12px" }}>{message}</span>
          </>
        );
      };
    const getExperts =()=>{
        getRerouteUser().then((res) => {
          if (res===undefined) return;
            if (res.data.success) {
              let updatedData = res.data.data.users.filter((exp) => {
                exp.label = exp.firstName + " " + exp.lastName;
                exp.value = exp.userUuid;
                exp.name = exp.firstName + " " + exp.lastName;
                return exp;
              });
              setOptions(updatedData.filter(obj=>{
                if(obj.userUuid !==expertRecordsState.experts[0].userUuid){
                    return obj;
                }
              }));
            }
          });
    }
    const modalState = useSelector((state) => state.domain);
    const dispatch = useDispatch();
    const { advanceFilterModalToggle, cmrRefreshPage, cmrClickedData} = bindActionCreators(Actions, dispatch);
    const onClickButtons= ()=>{
        isLoaded(true);
        let answerUuids = [];
        expertRecordsState.clickedData.filter(obj=>{
            //  console.log(obj.openAnsweredExperts.includes(selectedExpert.value),obj.openAnsweredExperts, selectedExpert.value);
            if(obj.openAnsweredExperts.includes(selectedExpert.value) === false){
                answerUuids.push(obj.answerUuid);
            }
        })
        let payload ={
            'fromUserId':expertRecordsState.experts[0].userUuid,
            'toUserId':selectedExpert.value,
            'answerIds': answerUuids
          }
          if(answerUuids.length === 0){
            toast.error(successMsg('The selected expert may already have these question as in rejected/answered state.'));
            cmrRefreshPage(1234567);
            cmrClickedData(null);
            advanceFilterModalToggle({ bool: false, value: "" });
            return;
          }
        transferOwnership(payload).then(res=>{
          if (res===undefined) return;
            if(res.data.success){
              // toast.success(successMsg(res.data.message));
              cmrRefreshPage(1234567);
              cmrClickedData(null);
              advanceFilterModalToggle({ bool: false, value: "" });
              isLoaded(false);
            }
          })
    }
    const onChangeSelectedOption = (value) => {
        setSelectedExpert(value);
    };
    useEffect(() => {
        getExperts();
    }, [])
    return (
      <>
        {/* <Modal show={modalState.modalState}
            onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
            // centered={true}
            size={"md"}
            style={{marginTop:"5%"}}
            backdrop="static"
            // scrollable={true}
        >
            <ModalHeader className="reroutetitleModal" closeButton closeVariant="white">
                <ModalTitle>
                    <h5 className="headingModal" style={{display:'flex',alignItems:'center',marginBottom:'0px'}}><i className="fa fa-handshake-o" style={{ paddingRight: "7px", fontSize: "24px" }}></i> Answer Transfer Ownership</h5>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className="row" style={{paddingLeft:'3.0rem',paddingRight:'3.0rem',paddingBottom:'5px', textAlign:'center'}}>
                    <div className="container">
                        <div className="mb-2" style={{display:'flex', justifyContent:'center', alignItems:'baseline'}}>
                            <span>Choose Expert:&nbsp;</span><MultiSelectCm value={selectedExpert} onChangeFunc={onChangeSelectedOption} disabled={false} options={options} isMulti={false}  />
                        </div>
                        {!isLoading && <div>
                            <button className="cancelBtn" onClick={()=>advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>&nbsp;<button className="rerouteBtn" disabled={selectedExpert.length === 0 }  onClick={()=>onClickButtons()}>Submit</button></div>}
                        {isLoading && 
                        <div>
                            <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Transferring</button>
                        </div>}
                    </div>
                </div>
            </ModalBody>
        </Modal> */}


        <Modal
          show={modalState.modalState}
          onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
          centered={true}
          size={"lg"}
        // dialogClassName={styles.modalDialog}
        >
          <Modal.Header closeButton>
            <Modal.Title style={modalTitleStyle}>
              {/* <i className="fa fa-files-o"></i> */}
              {/* &nbsp;&nbsp;  */}
              <span style={{ display: "flex", alignItems: "baseline " }}> <i className="fa fa-handshake-o" style={{ paddingRight: "7px", fontSize: "24px" }}></i> 
              Answer Transfer Ownership
              </span>




              {/* <i className="fa fa-files-o"></i> &nbsp;&nbsp;Data Export */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ marginTop: "5px", width: "90%", margin: "auto", marginInline: '0px', }}>


              <div
                style={{
                  display: "flex",
                  // color: "grey",
                  fontSize: "16px",
                  alignItems: "baseline",
                  justifyContent: 'center',
                  marginTop: '10px',
                  fontWeight: '300',
                  gap: 5
                }}
              >
                <div
                  style={textStyles1}
                >
             Choose Expert&nbsp;
                </div>
                <div style={{ marginTop: '12px', width: "200px", marginLeft: "10px" }}>
                  <span>
                    {/* <MultiSelectCmTwo
                     disabled={false}
                     value={domains}
                     onChangeFunc={(e) => setDomain(e)}
                     isMulti={true}
                     options={filterDomainsForComponent2(userState.cmTopics)}
                   /> */}
                    <Select
                      labelInValue
                      options={options} 
                      value={selectedExpert}
                      // defaultValue={{ label: 'All', value: null }}
                      onChange={onChangeSelectedOption} 
                      // defaultvalue={domains}
                      placeholder="Select Expert"
                      popupClassName={Styles.selectCss}
                      size="middle"
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
                    // size={"medium"}
                    // width={"100px"}
                    />
                    {/* <ReusableMultiSelect
                     value={domains}
                     onChange={(e) => changeDomain(e)}
                     options={filterDomainsForComponent2(userState.cmTopics)}
                     placeholder="Select Domain"
                     maxTagPlaceholder={`${domains?.length || 0} selected`}
                     allowClear={true}
                     disabled={false}
                   /> */}
                  </span>
                </div>
              </div>
           
            </div>


            {!isLoading && <div style={{
              display: "flex",
              // color: "grey",
              fontSize: "16px",
              alignItems: "baseline",
              justifyContent: 'center',
              marginTop: '10px',
              fontWeight: '300',
              gap: 5,
              marginRight: "0px",
              marginLeft:"38px"
            }}
            >
              <button style={{
                padding: '8px 12px 8px 12px',
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '24px',
                fontWeight: 400,
                boxShadow: ' 0px 1px 2px 0px #1018280D',
                color: '#2A364A',
                border: '1px solid  #fff',
                height: '40px',
                minWidth: '88px',
                background: " #F6F7F8",
                marginBottom: '14px',
                fontWeight: 400,
                border: " 1px solid #E0E2E6"


                //  font-weight: 400;    
              }}
                onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>&nbsp;
              <button
                style={{
                  padding: '8px 12px 8px 12px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  lineHeight: '24px',
                  fontWeight: 400,
                  boxShadow: '0px 1px 2px 0px #1018280D',
                  color: '#FFFFFF',
                  border: '1px solid  #fff',
                  height: '40px',
                  minWidth: '88px',
                  background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                  marginBottom: '14px',
                  cursor:selectedExpert.length === 0   ? "not-allowed" : "pointer",
                   opacity:selectedExpert.length === 0 ?"0.7":"",
                      // cursor:question === "" || isDisabled(answer) === ''?"not-allowed":"pointer"


                }}
                disabled={selectedExpert.length === 0 }  onClick={()=>onClickButtons()}
                
                >Transfer</button>
            </div>}
            {isLoading &&
              <div className="mt-2 mb-2" style={{  display: "flex",
                // color: "grey",
                fontSize: "16px",
                alignItems: "baseline",
                justifyContent: 'center',
                marginTop: '10px',
                fontWeight: '300',
                gap: 5,
                marginRight: "0px",
                marginLeft:"38px" }}>
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    color: '#FFFFFF',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    marginBottom: '14px',
                    cursor: "not-allowed",
                    opacity:"0.7"

                  }}
                  className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Transferring...</button>
              </div>}
            <div
              style={{
                display: "flex",
                // color: "grey",
                fontSize: "16px",
                alignItems: "baseline",
                justifyContent: 'center',
                // marginTop: '10px',
                fontWeight: '300',
                gap: 5,
                marginRight: "0px"
              }}
            >

            </div>
            {/* <div
             className="searchsuggestionModal"
             style={{ textAlign: "end" }}
           >
             <button
               style={{
                 padding: '8px 12px 8px 12px',
                 borderRadius: '6px',
                 fontSize: '14px',
                 lineHeight: '24px',
                 fontWeight: 400,
                 boxShadow: '0px 1px 2px 0px #1018280D',
                 color: '#FFFFFF',
                 border: '1px solid  #fff',
                 height: '40px',
                 minWidth: '88px',
                 background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                 marginBottom: '14px',
                 marginTop: "15px"
               }}
             // onClick={() => onClickSubmit()}
             >
               Submit
             </button>
           </div> */}
          </Modal.Body>
        </Modal>
        </>
    )
}
